module.exports = __webpack_public_path__ + "5d1d6dcedcd88b28de466b43914afdc1.pdf";